// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h0IC","colBig":"styles_colBig__1_UL7","colSmall":"styles_colSmall__hiyzK"};